import React from 'react';
import useScreenOrientation from './helpers/useScreenOrientation';

export default function UserForm({ isVisible, setView, setUserID }: any) {

  const isLandscape = useScreenOrientation();

  const [name, setName] = React.useState("");
  const [nameError, setNameError] = React.useState(false);

  const [cc, setCC] = React.useState(" ");
  const [ccError, setCCError] = React.useState(false);

  const [phone, setPhone] = React.useState(" ");
  const [phoneError, setPhoneError] = React.useState(false);

  const [city, setCity] = React.useState(" ");
  const [cityError, setCityError] = React.useState(false);

  const [invoice, setInvoice] = React.useState("");
  const [invoiceError, setInvoiceError] = React.useState(false);

  const [promissoryNote, setPromissoryNote] = React.useState("");
  const [promissoryNoteError, setPromissoryNoteError] = React.useState(false);

  const [acceptTerms, setAcceptTerms] = React.useState(false);
  const [acceptTermsError, setAcceptTermsError] = React.useState(false);

  const [sendingForm, setSendingForm] = React.useState(false);

  const checkName = (name: string) => {
    const filteredName = name.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
    setName(filteredName)
    setNameError(filteredName === '')
  };

  const checkCC = (cc: string) => {
    setCC(cc)
    //setCCError(cc === '')
    setCCError(false)
  };

  const checkPhone = (phone: string) => {
    setPhone(phone)
    //setPhoneError(phone === '')
    setPhoneError(false)
  };

  const checkInvoice = (invoice: string) => {
    setInvoice(invoice)
    //setInvoiceError(invoice === '')
    setInvoiceError(false)
  };

  const checkPromissoryNote = (promissoryNote: string) => {
    setPromissoryNote(promissoryNote)
    //setPromissoryNoteError(false);
    setPromissoryNoteError(promissoryNote === '')
  };

  const checkCity = (city: string) => {
    setCity(city)
    //setCityError(city === '')
    setCityError(false)
  };

  const checkTerms = (accepted: boolean) => {
    setAcceptTerms(accepted)
    setAcceptTermsError(accepted === false)

    checkName(name)
    checkPromissoryNote(promissoryNote)
  };

  const verifyAllInputs = () => {
    checkName(name)
    checkCC(cc)
    checkPhone(phone)
    checkInvoice(invoice)
    checkCity(city)
    checkPromissoryNote(promissoryNote)
    checkTerms(acceptTerms)
    if(nameError === false && 
      ccError === false &&
      phoneError === false &&
      invoiceError === false &&
      promissoryNoteError === false &&
      cityError === false &&
      acceptTermsError === false &&
      acceptTerms === true){
        SendUserDataForm()
    }
  };

  const SendUserDataForm = () => {
    setSendingForm(true)
    fetch('https://x0cv9pf8rj.execute-api.us-east-1.amazonaws.com/api/activaciones/registre', { //https://x0cv9pf8rj.execute-api.us-east-1.amazonaws.com/api/registre_runner
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(
        {
          "cc": cc,
          "name": name,
          "phone": phone,
          "city": city,
          "boucher": invoice,
          "promissory_note": promissoryNote,
        }
      )
    }
    ).then(response => {
      setSendingForm(false)
      response.json().then(jSonResponse => {
        if (jSonResponse.statusCode === 200) {
          console.log("User Data Form Sent!")
          setUserID(jSonResponse.id)
          setView("Instructions")
        }
        console.log(jSonResponse)
      })
    }
    )
      .then(responseData => {
        console.log(responseData)
      })
      .catch(error => {
        console.error("Error sending User Data Form")
        console.error(error)
        setSendingForm(false)
      });
  }

  return (
    <div className={`full-userform-container ${isVisible === true ? 'active' : 'hidden'}`}>

      <div className={`userform-container ${isLandscape ? '' : 'portrait'}`}>

        <div className={`userform-container-title ${isLandscape ? '' : 'portrait'}`}>Regístrate</div>

        <div className={`userform-container-grid ${isLandscape ? '' : 'portrait'}`}>

          <div className={`userform-input-container ${isLandscape ? '' : 'portrait'}`}>
            <div className={`userform-input-title ${nameError ? 'error' : ''} ${isLandscape ? '' : 'portrait'}`}>Nombre completo</div>
            <input value={name} className={`userform-input ${nameError ? 'error' : ''}`} type='text' onChange={(e: any) => { checkName(e.target.value) }}></input>
            <div className='userform-warning-text'>{nameError ? "Este campo es obligatorio." : ""}</div>
          </div>

          {/* <div className='userform-input-container'>
            <div className={`userform-input-title ${phoneError ? 'error' : ''} ${isLandscape ? '' : 'portrait'}`}>Celular</div>
            <input className={`userform-input ${phoneError ? 'error' : ''}`} type='numeric' onChange={(e: any) => { checkPhone(e.target.value) }}></input>
            <div className='userform-warning-text'>{phoneError ? "Este campo es obligatorio." : ""}</div>
          </div>

          <div className='userform-input-container'>
            <div className={`userform-input-title ${cityError ? 'error' : ''} ${isLandscape ? '' : 'portrait'}`}>Ciudad</div>
            <input className={`userform-input ${cityError ? 'error' : ''}`} type='text' onChange={(e: any) => { checkCity(e.target.value) }}></input>
            <div className='userform-warning-text'>{cityError ? "Este campo es obligatorio." : ""}</div>
          </div>

          <div className='userform-input-container'>
            <div className={`userform-input-title ${ccError ? 'error' : ''} ${isLandscape ? '' : 'portrait'}`}>Documento de identidad</div>
            <input className={`userform-input ${ccError ? 'error' : ''}`} type='text' onChange={(e: any) => { checkCC(e.target.value) }}></input>
            <div className='userform-warning-text'>{ccError ? "Este campo es obligatorio." : ""}</div>
          </div> */}

          {/* <div className='userform-input-container'>
            <div className={`userform-input-title ${invoiceError ? 'error' : ''} ${isLandscape ? '' : 'portrait'}`}>Número de factura o recibo</div>
            <input className={`userform-input ${invoiceError ? 'error' : ''}`} type='text' onChange={(e: any) => { checkInvoice(e.target.value) }}></input>
            <div className='userform-warning-text'>{invoiceError ? "Este campo es obligatorio." : ""}</div>
          </div> */}

          <div className='userform-input-container'>
            <div className={`userform-input-title ${promissoryNoteError ? 'error' : ''} ${isLandscape ? '' : 'portrait'}`}>Número de Pagaré</div>
            <input className={`userform-input ${promissoryNoteError ? 'error' : ''}`} type='number' onChange={(e: any) => { checkPromissoryNote(e.target.value) }}></input>
            <div className='userform-warning-text'>{promissoryNoteError ? "Este campo es obligatorio." : ""}</div>
          </div>

          <div className='userform-input-container'>
            <div className={`userform-checkbox-text ${isLandscape ? '' : 'portrait'}`}>*Si no conoce su número de pagaré, debe solicitarlo al almacén en donde realizó la compra.</div>
          </div>

          <div className={`userform-input-checkbox ${acceptTermsError ? 'error' : ''}`}>
            <input id='legal_terms_accept' type='checkbox' onChange={(e: any) => { checkTerms(e.target.checked) }}></input>
            <div className='userform-checkbox-text'>
              Acepto los <a className='userform-checkbox-link' href='https://www.sistecredito.com/terminos-y-condiciones-generales/' target='_blank' rel='noreferrer'>Términos y condiciones de Sistecredito</a>
            </div>
          </div>
        </div>

        <div className={`userform-send-button ${isLandscape ? '' : 'portrait'} ${(acceptTermsError || nameError || promissoryNoteError || sendingForm) ? 'error' : ''}`} onClick={() => { if (!acceptTermsError && !nameError && !promissoryNoteError && !sendingForm) verifyAllInputs() }}>
          <div className={`userform-send-button-text ${isLandscape ? '' : 'portrait'}`}>{sendingForm === true ? 'Enviando' : 'Continuar'}</div>
        </div>

      </div>
    </div>
  );
}